export default "__VITE_ASSET__af50138a__"